document.addEventListener('DOMContentLoaded', function(){
    if(document.querySelector('.jsPathAnim')){

        let first = document.querySelector('.jsPathAnim').getElementById('first');
        let second = document.querySelector('.jsPathAnim').getElementById('second');
        let apple = document.querySelector('.jsPathApple');
        
        var Visible = function (target) {
            var targetPosition = {
                    top: window.pageYOffset + target.getBoundingClientRect().top,
                    left: window.pageXOffset + target.getBoundingClientRect().left,
                    right: window.pageXOffset + target.getBoundingClientRect().right,
                    bottom: window.pageYOffset + target.getBoundingClientRect().bottom
                },
                    windowPosition = {
                    top: window.pageYOffset,
                    left: window.pageXOffset,
                    right: window.pageXOffset + document.documentElement.clientWidth,
                    bottom: window.pageYOffset + document.documentElement.clientHeight
                };
        
            if (targetPosition.bottom > windowPosition.top &&
                targetPosition.top < windowPosition.bottom && 
                targetPosition.right > windowPosition.left && 
                targetPosition.left < windowPosition.right) {
        
                if(target == document.querySelector('.section-path__bg svg').getElementById('first')){
                    setTimeout(function(){document.querySelector('.section-path__bg svg').getElementById('1-anim').beginElement();}, 500)
                    if(!document.querySelector('.jsPathMain').classList.contains('_run')){
                        document.querySelector('.jsPathMain').classList.add('_run');
                    }
        
                    if(!document.querySelector('.jsPathElements').classList.contains('_run-main')){
                        document.querySelector('.jsPathElements').classList.add('_run-main');
                    }
                }
         
                if(target == document.querySelector('.section-path__bg svg').getElementById('second')){
                    setTimeout(function(){ document.querySelector('.section-path__bg svg').getElementById('second-anim').beginElement();}, 500)
                    if(!document.querySelector('.jsPathTree').classList.contains('_run')){
                        document.querySelector('.jsPathTree').classList.add('_run');
                    }
        
                    if(!document.querySelector('.jsPathElements').classList.contains('_run-tree')){
                        document.querySelector('.jsPathElements').classList.add('_run-tree');
                    }
                }
        
                if(target == document.querySelector('.jsPathApple')){
                    setTimeout(function(){document.querySelector('.jsPathApple').classList.add('_run')}, 2000)
                }
            };
        };
        
        window.addEventListener('scroll', function() {
            Visible (first);
            Visible (second);
            Visible (apple);
        });
        
        Visible (first);
        Visible (second);
        Visible (apple);
        
        
    }
})